@if (form.view) {
    @if (form.view) {
        <form #formRef="ngForm" (ngSubmit)="submit()" @fadeInOut>
            <sf-form name="form" [view]="form.view" [(ngModel)]="form.model"></sf-form>
            @if (!options.sticky_actions && options.actions_separator) {
                <hr />
            }
            <ngxh6-form-actions
                [form]="form"
                [options]="options"
                [formRef]="formRef"
                [valid]="formRef.valid"
                (cancel)="cancel()"
                (delete)="delete()"
                (archive)="archive($event)"
            ></ngxh6-form-actions>
        </form>
    }
} @else {
    <ngxh6-loading-or-error [error]="form.error"></ngxh6-loading-or-error>
}
